import React, { useEffect } from "react";
import Header from "../components/dynamic/Header";
import ProofLoader from "../components/view-specific/ProofLoader";
import { useAuthStore } from "../store/authStore";

const ProofGenerationView: React.FC = () => {
  const { nextScreen, viewData } = useAuthStore();
  const { proofGeneration } = viewData;

  // Simulate proof generation with a timeout
  useEffect(() => {
    const timer = setTimeout(() => {
      nextScreen();
    }, 3000);

    return () => clearTimeout(timer);
  }, [nextScreen]);

  return (
    <div className="flex flex-col items-center">
      <Header
        title={proofGeneration.title}
        subheader={proofGeneration.subheader}
      />

      <ProofLoader />
    </div>
  );
};

export default ProofGenerationView;
